import { gql } from '@apollo/client';

export const FETCH_NOTIFICATION_RULES_FIND_ONE_FRAGMENT = gql`
  fragment NotificationRules_FindOneFragment on NotificationRulesObjectFind {
    count
    rules {
      id
      condition {
        conditions {
          logOp
          conditions {
            param
            op
            type
            value
          }
          op
          param
          type
          value
        }
        logOp
      }
      events
      isActive
      name
      whatsapp {
        useDelay
        delayType
        delay
        sendTo
      }
      sms {
        useDelay
        delayType
        delay
        sendTo
      }
      email {
        useDelay
        delayType
        delay
        sendTo
      }
    }
  }
`;
